import { createSlice } from "@reduxjs/toolkit"
import logger from "../Logger"

const pageLogger = logger.child({ store: "form-game" })
const initialState = {
  scenario_form: "",
  details_setup_type_form: {},
  details_form: {},
  // AI-support selections lifted here so Step 3 (review) + the commit step can read
  // what was chosen in Step 2. Two regions write disjoint fields:
  //   Scenario evolution (react bots): evolution, reactBotIds, reactCustomBots
  //   AI Stakeholders   (player bots): playerRoleBots, playerCustomBots
  // At commit these become session.bots (react), session.roleBots (player), session.customBots.
  ai_support_form: {
    evolution: "scripted", // 'scripted' | 'adaptive' — adaptive turns the Adversary (attacker) react bot on
    facilitatorOn: false,
    meetingLink: "",
    stakeholdersScored: false, // AI stakeholders take scored turns (single-player / facilitator-run)
    manualMode: false, // Facilitator Manual mode: AI replies wait for the facilitator (needs a facilitator)
    reactBotIds: [], // selected library react-bot keys (Scenario evolution list)
    reactCustomBots: [], // [{ key, name, role, persona, behavior:'react' }]
    playerRoleBots: {}, // { role: botKey } — library autoplay + custom player bots (AI Stakeholders)
    playerCustomBots: [], // [{ key, name, role, persona, behavior:'autoplay' }]
    reactBotRisk: {}, // { botKey: 'cautious'|'balanced'|'bold' } — react bots' risk appetite
    playerBotRisk: {}, // { botKey: 'cautious'|'balanced'|'bold' } — AI stakeholders' risk appetite
    stakeholders: [], // display labels for the Step-3 review card
  },
}

const GameFormSlice = createSlice({
  name: "GAME_FORM",
  initialState,
  reducers: {
    updateGameForm: (state, action) => {
      const { formName, formData } = action.payload
      pageLogger.info({ formName, formData }, `form data received in update method`)
      state[formName] = JSON.parse(JSON.stringify(formData))
    },
    // MERGE into the form (updateGameForm REPLACES it). For forms written by more than one
    // component — ai_support_form is written by TWO AiSupportExtras instances — replace
    // semantics forced every writer to re-spread the whole form from a snapshot, and any
    // stale snapshot silently erased the other writer's fields (the bot-wipe race). With
    // patch semantics each writer dispatches ONLY the fields it owns, making that wipe
    // structurally impossible.
    patchGameForm: (state, action) => {
      const { formName, formData } = action.payload
      state[formName] = { ...(state[formName] ?? {}), ...JSON.parse(JSON.stringify(formData)) }
    },
    resetGameForm: (state, action) => {
      const { formName } = action.payload
      const initialFormData = initialState[formName]
      state[formName] = initialFormData
    },
  },
})

export const GameFormActions = GameFormSlice.actions

export default GameFormSlice
